var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',{attrs:{"data":_vm.resourceData,"columns":_vm.columns,"resizable":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }